import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import logoBlanco from "../../assets/images/logo_blanco.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: '#000', color: '#fff' }}>
      <Container className="py-4 ">
        <Row className="align-items-start text-md-start">
          {/* Columna 1: Logo + enlaces principales  */}
          <Col md={3} className="mb-3 mb-md-0 d-flex flex-column align-items-md-start justify-content-center">
            <h6 className="text-white mb-2">Navegación</h6>
            <Nav className="flex-column" style={{ paddingLeft: 0 }}>
              <Nav.Item>
                <Nav.Link as={Link} to="/" className="text-white ps-0">Inicio</Nav.Link>
              </Nav.Item>
              
              {/* 
              <Nav.Item>
                <Nav.Link as={Link} to="/cita" className="text-white ps-0">Pide cita</Nav.Link>
              </Nav.Item> 
              */}
              
              <Nav.Item>
                <Nav.Link as={Link} to="/masajes" className="text-white ps-0">Nuestros masajes</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="/contacto" className="text-white ps-0">Contacto</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          {/* Columna 2: Enlaces legales */}
          <Col md={3} className="mb-3 mb-md-0 d-flex flex-column align-items-md-start justify-content-center">
            <h6 className="text-white mb-2">Legal</h6>
            <Nav className="flex-column" style={{ paddingLeft: 0 }}>
              <Nav.Item>
                <Nav.Link as={Link} to="/aviso-legal" className="text-white ps-0">Aviso Legal</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="/politica-privacidad" className="text-white ps-0">Política de privacidad</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="/proteccion-datos" className="text-white ps-0">Política de protección de datos</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          {/* Columna 3: Información de contacto */}
          <Col md={3} className="mb-3 mb-md-0 d-flex flex-column align-items-md-start justify-content-center">
            <h6 className="text-white mb-2">Contacto</h6>
            <p className="mb-1" style={{ color: '#FFF' }}>Tel: 621 06 10 16</p>
            <p className="mb-1" style={{ color: '#FFF' }}>Email: contacto@manusfortis.es</p>
            <p className="mb-0" style={{ color: '#FFF' }}>Calle Asarau 20 1º B, Castellón</p>
          </Col>

          {/* Columna 4: Copyright y logo final */}
          <Col
            md={3}
            className="d-flex flex-column align-items-center align-items-md-end justify-content-center"
          >
            <Link
              to="/"
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: '#fff',
                marginBottom: '1rem'
              }}
            >
              <img
                src={logoBlanco}
                alt="Logo"
                style={{ height: '30px', marginRight: '0.5rem' }}
              />
              Manus Fortis
            </Link>
            <p className="mb-0">&copy; {currentYear} Manus Fortis</p>
          </Col>

        </Row>
      </Container>
    </footer>
  );
};

export default Footer;